import { Component } from '@angular/core';
import { ToggleComponent } from '../toggle/toggle.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalService } from 'src/_service/GlobalService';

@Component({
  selector: 'app-wakelock',

  templateUrl: './wakelock.component.html',
  styleUrl: './wakelock.component.scss',
  imports: [
    ToggleComponent,
    TranslateModule, FormsModule],
})
export class WakelockComponent {

  isAvailable = false;
  wakeLock = null;
  isActive = false;

  constructor(
    private _globalService: GlobalService
  ) {
    if(!this._globalService.isInBrowser) return;
    
    if ("wakeLock" in navigator) {
      this.isAvailable = true;
      document.addEventListener("visibilitychange", this.visibilitychangeListener);
    } else {
      console.warn('Screen wake lock is not supported')
    }
  }

  ngOnDestroy() {
    if(!this._globalService.isInBrowser) return;

    this.releaseWakelock();
    document.removeEventListener("visibilitychange", this.visibilitychangeListener)
  }

  toggleWakelock(value) {
    if (value) {
      this.setWakelock()
    } else {
      this.releaseWakelock();
    }
  }

  async setWakelock() {
    if(!this._globalService.isInBrowser) return;
    // create an async function to request a wake lock
    try {
      this.wakeLock = await navigator.wakeLock.request("screen");
      this.isActive = true
      this.wakeLock.addEventListener("release",this.wakeLockReleaselistener);

    } catch (err) {
      // The Wake Lock request has failed - usually system related, such as battery.
      console.log('wakelock error', err.name, err.message)
      this.isActive = false;
    }
  }

  wakeLockReleaselistener = () => {
    if(this.wakeLock)
      this.wakeLock.removeEventListener("release", this.wakeLockReleaselistener)
    this.isActive = false;
  }

  visibilitychangeListener = async () => {
    if(!this._globalService.isInBrowser) return;

    if (this.wakeLock !== null && document.visibilityState === "visible") {
      this.setWakelock();
    }
  }

  releaseWakelock() {
    if (!this.wakeLock) {
      this.isActive = false;
      return;
    }
    this.wakeLock.release().then(() => {
      this.isActive = false;
      this.wakeLock = null;
    });
  }
}
